import { RailSlide } from 'components/SplitRailShowcase/SplitRailShowcase'
import { HP } from 'components/basic/HP'
import styles from 'components/SplitRailShowcase/SplitRailShowcase.module.scss'
import { Img } from 'components/basic/Img'
import React from 'react'

export const autopilot: RailSlide = {
	leftSide: (
		<HP
			title={'Stay cool with automatic temperature adjustments'}
			titleClass={styles.text_header}
			type="h3"
			paragraphClass={styles.text_paragraph}
			paragraphs={['Let the Pod control the temperature of your side of the bed, personalizing it based on your sleep schedule, sleep phases, comfort preferences, and environmental conditions.']}
		/>
	),
	rightSide: (
		<Img
			src={'https://eightsleep.imgix.net/autopilot_screen_2880d8d8-b0b5-4008-b7db-9767b6299d4b.svg?v=1655150237'}
			alt="Eight Sleep mobile app alerting that the Pod is automatically adjusting the bed temperature because the room is very warm."
			simple={true}
		/>
	),
}

export const alarm: RailSlide = {
	leftSide: (
		<HP
			title={'Wake up energized with a vibration & thermal alarm'}
			titleClass={styles.text_header}
			type="h3"
			paragraphClass={styles.text_paragraph}
			paragraphs={['The Pod’s proprietary GentleRise alarm silently wakes you up with chest-level vibration and gradual thermal change, without disturbing your partner.']}
		/>
	),
	rightSide: (
		<Img
			src={'https://eightsleep.imgix.net/autopilot_screen_b0f254b7-1f11-4c18-b89e-ea995b3acd99.svg?v=1679002714'}
			alt="Eight Sleep mobile app alarm screen"
			simple={true}
		/>
	),
}

export const tracking: RailSlide = {
	leftSide: (
		<HP
			title={'Get a view into your sleep and health'}
			titleClass={styles.text_header}
			type="h3"
			paragraphClass={styles.text_paragraph}
			paragraphs={['Take the guesswork out of sleep by accessing reports on your sleep phases, sleep time, HR, HRV, and receive insights on what you can do to optimize each of them.']}
		/>
	),
	rightSide: (
		<Img
			src={'https://eightsleep.imgix.net/insight_screen_1.png?v=1658421972'}
			alt="Eight Sleep mobile app alerting that the Pod is automatically adjusting the bed temperature because the room is very warm."
			simple={true}
			dprHeight={360}
		/>
	),
}

export const apps: RailSlide = {
	leftSide: (
		<HP
			title={'Gain access to new features and upgrades'}
			titleClass={styles.text_header}
			type="h3"
			paragraphClass={styles.text_paragraph}
			paragraphs={['Receive continuous software updates and new features over the air, including integrations with platforms like Apple Health and Google Fit.']}
		/>
	),
	rightSide: (
		<Img
			src={'https://eightsleep.imgix.net/health_integrations.png?v=1690399485'}
			alt="Eight Sleep mobile app alerting that the Pod is automatically adjusting the bed temperature because the room is very warm."
			simple={true}
			dprHeight={250}
		/>
	),
}
